import TopBar from './TopBar';
import LeftMenu from './LeftMenu';
import MainPanel from './MainPanel';
import PanelAchievements from './PanelAchievements';
import PanelScoringRules from './PanelScoringRules';
import PanelBadgeRules from './PanelBadgeRules';
import PanelUsers from './PanelUsers';
import PanelSummary from './PanelSummary';
import PanelActivities from './PanelActivities';
import PanelDashboard from './PanelDashboard';
import PanelFrameGenerator from './PanelFrameGenerator';
import PanelSwag from './PanelSwag';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {Box} from '@mui/material';

import './AppMain.css';
import PanelFAQ from './PanelFAQ';

export const AppMain = () => {
    const dispatch = useDispatch();
    const selectedMenu = useSelector((state) => state.menu.selectedMenu);
    const navigate = useNavigate();

    const handleMenuSelect = (menu) => {
        dispatch({ type: 'menu/selectMenu', payload: menu });
        let urlPath = menu.replace(' ', '');
        urlPath = urlPath.charAt(0).toLowerCase() + urlPath.slice(1);
        navigate(`/in/${urlPath}`);
    };

    return (
            <Box className='app-container' sx={{
                    backgroundColor: (theme) => theme.palette.appLayer.main,
                }}>
                <LeftMenu onMenuSelect={handleMenuSelect} dispatch={dispatch} />
                <MainPanel>
                    {selectedMenu === 'Activities' && <PanelActivities />}
                    {selectedMenu === 'Levels' && <PanelAchievements />}
                    {selectedMenu === 'Summary' && <PanelSummary />}
                    {selectedMenu === 'Scoring Rules' && <PanelScoringRules />}
                    {selectedMenu === 'Users' && <PanelUsers />}
                    {selectedMenu === 'Badge Rules' && <PanelBadgeRules />}
                    {selectedMenu === 'Dashboard' && <PanelDashboard />}
                    {selectedMenu === 'FAQ' && <PanelFAQ />}
                    {selectedMenu === 'Digital Swag' && <PanelFrameGenerator />}
                    {selectedMenu === 'SWAG' && <PanelSwag />}
                </MainPanel>
            </Box>
    )
}

